import type { StripeGetCustomerResponse } from "@/common/types/stripe";
import axiosClient from "@/lib/axios/axiosClient";

export const getCustomerSession = async ({
  email,
}: {
  email: string;
}): Promise<StripeGetCustomerResponse> => {
  const response = await axiosClient.post<StripeGetCustomerResponse>(
    "/stripe-get-customer-session",
    {
      email: email,
    },
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );
  return response.data;
};
